export default __webpack_public_path__ + "static/media/dog.7e0c2bfd.svg";